import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ChevronDown, ChevronRight, ClockArrowRotateLeft } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { RevisionAction } from 'client/blocks/RevisionActions/RevisionActions';
import { routes } from 'client/lib/routes';
import { InstallableApp } from 'client/model/skill';
import { getCanEditApp } from 'client/utils';
import { getRevisionSlug } from 'client/utils/time';
import * as keyset from 'i18n/RevisionStatus';

import { RevisionRow } from './RevisionRow';
import styles from './RevisionStatus.module.scss';

interface Props {
    installableApp: InstallableApp;
    setInstallableApp: (app: InstallableApp) => void;
}

const t = i18n(keyset);

export const RevisionStatus = ({ installableApp, setInstallableApp }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { pathname } = useLocation();

    const revisionsDisable = !installableApp.revisions?.length;
    const actionDisabled = !getCanEditApp(installableApp);

    return (
        <RevisionAction installableApp={installableApp} setInstallableApp={setInstallableApp}>
            <div className={styles.revisionContainer}>
                <Button
                    className={styles.controlButton}
                    onClick={() => setIsOpen((state) => !state)}
                    title={t('revision-hint')}
                    view="flat"
                    width="max"
                    disabled={revisionsDisable}
                >
                    <Icon
                        className={clx(styles.icon, revisionsDisable && styles.icon_disabled)}
                        data={ClockArrowRotateLeft}
                    />
                    {t('revision-history')}
                    <Icon data={isOpen ? ChevronDown : ChevronRight} />
                </Button>
                {isOpen && (
                    <ul className={styles.list}>
                        {installableApp.revisions
                            .filter((revision) => !revision.isActive)
                            .map((revision) => {
                                const isCurrentRevision =
                                    pathname ===
                                    routes.app.installableAppRevision(
                                        installableApp.channel,
                                        installableApp.id,
                                        getRevisionSlug(revision),
                                    );
                                return (
                                    <RevisionRow
                                        key={revision.id}
                                        revision={revision}
                                        isCurrentRevision={isCurrentRevision}
                                        actionDisabled={actionDisabled}
                                    />
                                );
                            })}
                    </ul>
                )}
            </div>
        </RevisionAction>
    );
};
